// formatting + reason labels shared by receiver mfca components.

export const fmtMoney = (v) =>
  `$${Number(v || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const fmtLbs = (v) =>
  Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 1 });

export const fmtPct = (v) => `${Number(v || 0).toFixed(1)}%`;

// maps the db enum to a display key that feeds react-i18next t().
// keys match what's already in locales (en.json/fr.json).
export const REJECTION_REASON_LABELS = {
  wrong_material: "Wrong material",
  contaminated: "Contaminated",
  damaged: "Damaged",
  expired: "Expired",
  other: "Other",
};

// rendered in this order on the recovery & loss rejection breakdown — mirrors
// REJECTION_REASONS in api/pages/receiver_mfca.py so inactive rows render in a
// consistent order regardless of which reasons happen to be active in a period.
export const REJECTION_REASONS = ["wrong_material", "contaminated", "damaged", "expired", "other"];

// fixed colors per reason — used by the rejection stacked bar and reason swatches.
// wrong/contam/damaged map to the existing receiver palette; expired/other reuse
// it consistently (lavender/grey) so the bar reads even with all 5 reasons active.
export const REJECTION_REASON_COLORS = {
  wrong_material: "#d4574e",
  contaminated: "#c97264",
  damaged: "#e0a030",
  expired: "#a0a7e6",
  other: "#7f8a99",
};

export const reasonLabel = (reason) =>
  reason ? REJECTION_REASON_LABELS[reason] || reason : null;

// threshold mirrored on the backend; see MIN_PICKUPS_FOR_RATING in receiver_mfca.py.
// kept here for the "n to date" copy on below-threshold rows.
export const MIN_PICKUPS_FOR_RATING = 5;

// acceptance rate below which a material or donor surfaces as "needing attention"
// on the recovery & loss page. display-only — backend doesn't gate on this, so
// no python mirror needed. tunable via this constant if the threshold ever needs
// to move; if it ever needs to be per-org configurable, that's a settings change.
export const PROBLEM_THRESHOLD_PCT = 95;
